import { useState, useCallback } from 'react';

/**
 * Hook para gerenciar configurações de estilo de camadas.
 * @param {string} storageKey Chave do localStorage para persistência
 * @param {Object} defaultStyles Estilos padrão por camada
 */
export default function useLayerStyleConfig(storageKey, defaultStyles) {
  const [layerStyles, setLayerStyles] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      const saved = raw ? JSON.parse(raw) : {};
      return { ...defaultStyles, ...saved };
    } catch {
      return defaultStyles;
    }
  });
  const [pendingStyles, setPendingStyles] = useState(layerStyles);
  const [open, setOpen] = useState(false);

  const handlePendingChange = useCallback((layerName, style) => {
    setPendingStyles((prev) => ({ ...prev, [layerName]: style }));
  }, []);

  const handleReset = useCallback(() => setPendingStyles(defaultStyles), [defaultStyles]);

  const handleSave = useCallback(() => {
    setLayerStyles(pendingStyles);
    try {
      localStorage.setItem(storageKey, JSON.stringify(pendingStyles));
    } catch {
      /* no-op */
    }
    setOpen(false);
  }, [pendingStyles, storageKey]);

  return {
    layerStyles,
    pendingStyles,
    open,
    setOpen,
    handlePendingChange,
    handleReset,
    handleSave,
  };
}
